// modules
import React, { FC } from 'react';
import { CloseIcon, Text, View } from '@upstox/upstox-ui';
import { useStore } from 'modules/Stores';
import { observer } from 'mobx-react';
import LocaleService from 'modules/Localization';
// typings
import { CreatePriceAlertsHeaderProps } from './typings';
// styles
import * as css from './styles';

const CreatePriceAlertsHeader: FC<CreatePriceAlertsHeaderProps> = ({
  closeModal,
}) => {
  const { scripData } = useStore('PriceAlertsStore');
  return (
    <View
      alignItems="center"
      justifyContent="space-between"
      css={css.container}
    >
      <Text css={css.title}>
        {LocaleService.translate('SET_PRICE_ALERTS_TITLE')}{' '}
        {scripData?.name}
      </Text>

      <CloseIcon css={css.closeIcon} onClick={closeModal} />
    </View>
  );
};

export default observer(CreatePriceAlertsHeader);
